var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.298584,
    y: 0.46521,
    width: 63.8084,
    height: 63.8084,
    rx: 6.96092,
    fill: "#F25767"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.302 22.2475C45.3216 22.7007 46.0014 23.6637 46.0014 24.74C46.0014 37.3159 38.2973 44.2836 33.4255 46.323C32.7458 46.6062 32.0093 46.6062 31.3296 46.323C25.2682 43.7738 18.8103 36.013 18.8103 24.74C18.8103 23.6637 19.4335 22.7007 20.4531 22.2475L31.3296 17.7157C31.6694 17.6024 32.0093 17.5457 32.4059 17.5457C32.7458 17.5457 33.0856 17.6024 33.4255 17.7157L44.302 22.2475ZM32.4059 42.8108C37.6741 40.1483 42.1493 33.917 42.3193 25.3632L32.4059 21.2279V42.8108Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon2);
export default __webpack_public_path__ + "static/media/Home_icon2.261d80330db1b23af4b41352716c590f.svg";
export { ForwardRef as ReactComponent };